<template>
  <div class="hcl-form-element-text">
    <input ref="fieldRef" class="hcl-form-element-text-input form-control" :class="{
      'is-valid': validationStatus === 'valid',
      'is-invalid': validationStatus === 'invalid'
    }" :name="fieldName" :type="props.definitionField.field.type" :readonly="isReadOnly(props.definitionField.field)"
      :value="props.dataField.value" @change="onChange" v-on:keyup.enter="onEnter"
      :widget="props.definitionField.field.widget?.widget" v-bind="generateDataAttributes" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

import { useElement } from '@/components/FormElement/element'

interface Props {
  definitionField: any
  dataField: any
  dataLookup: any
}

const props = withDefaults(defineProps<Props>(), {
  definitionField: undefined,
  dataField: undefined,
  dataLookup: undefined
})

const {
  fieldRef,
  isReadOnly,
  fieldName,
  validationStatus,
  generateDataAttributes
} = useElement(props)

onMounted(() => {
  if (props.definitionField.field.focus) fieldRef.value.focus()
})

const emit = defineEmits(['hcl-form-input-enter-key'])

const onEnter = () => {
  emit('hcl-form-input-enter-key', { fieldName: fieldName })
}

const onChange = (event) => {
  props.dataField.value = event?.target?.value ?? undefined
}
</script>

<style lang="scss" scoped>
.hcl-form-element-text {
  width: 100%;
}
</style>
